(function () {
  var SELECTOR = '.media-with-content__content';
  var DRIFT = 50; // pixels of movement across the full scroll pass

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var elements = [];
  var ticking = false;

  function collect() {
    elements = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  function update() {
    var viewportHeight = window.innerHeight;

    elements.forEach(function (el) {
      var rect = el.getBoundingClientRect();

      // Skip anything well outside the viewport
      if (rect.bottom < -200 || rect.top > viewportHeight + 200) return;

      // progress: 1 when entering from the bottom, -1 when leaving at the top
      var centre = rect.top + rect.height / 2;
      var progress = (centre - viewportHeight / 2) / (viewportHeight / 2);
      progress = Math.max(-1, Math.min(1, progress));

      el.style.transform = 'translateY(' + (progress * DRIFT).toFixed(2) + 'px)';
    });

    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  collect();
  update();

  var scroller = document.querySelector('.page-wrapper') || window;
  scroller.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    collect();
    update();
  }, { passive: true });

  document.addEventListener('shopify:section:load', function () {
    collect();
    update();
  });
})();